/**
 * @generated SignedSource<<89e08abf7b1bcac56eb6603bbe13f0c4>>
 * @relayHash 721e58beb9933f50ca102340a4b2c77b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 237b18da4f595f269f503d0f112c03e89f307c52ddc3d5f271e2434cf3572a96

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "237b18da4f595f269f503d0f112c03e89f307c52ddc3d5f271e2434cf3572a96",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
